export default __webpack_public_path__ + "static/media/checked.58e8bde3.svg";